import axios from "axios";

import { base_url } from "../constants/config";
import { eventDispatch } from "../hooks/useEventListener";
import { getStorage, putStorage } from "../hooks/useStorage";
import { objectPut, sleep } from "./common-service";

const localStorageTokenKey = `studTourismToken`;

export const getToken = () => {
    const token = localStorage.getItem(localStorageTokenKey);
    return token;
};

export const setToken = (token: string) => {
    localStorage.setItem(localStorageTokenKey, token);
};

export const removeToken = () => {
    localStorage.removeItem(localStorageTokenKey);
};

export const setUpInterceptors = () => {
    axios.interceptors.request.use(
        async (config: any) => {
            config.baseURL = base_url;
            const token = getToken();
            if (!!token) {
                config.headers["Authorization"] = token;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        },
    );
};

export const handleSuccess = (response: any) => {
    if (!Array.isArray(response) && typeof response.message === `string`) {
        response = [response];
    }
    (response || [])?.forEach?.((i: any, index: number) => {
        setTimeout(() => {
            eventDispatch(`THROW_SUCCESS`, i?.message ?? ``);
        }, 200 * index);
    });
    return response || [];
};

export let handleError = (error: any) => {
    console.error(error);
    if (typeof error === `string`) {
        error = { message: error };
    }
    if (!Array.isArray(error) && typeof error?.message === `string` && !Array.isArray(error?.response?.data)) {
        objectPut(error, `response.data`, [error?.response?.data]);
    }
    if (error?.response?.data) {
        (error?.response?.data ?? []).forEach((i: any, index: number) => {
            setTimeout(() => {
                if (i?.field) {
                    eventDispatch(`CALL_INPUT_ERROR`, { field: i?.field ?? ``, message: i?.message ?? `` });
                } else {
                    eventDispatch(`THROW_ERROR`, i?.message ?? error?.message ?? ``);
                }
            }, 200 * index);
        });
        return error?.response?.data ?? [];
    }
    if (error?.response?.data?.message) {
        eventDispatch(`THROW_ERROR`, error?.response?.data?.message);
        return error?.response?.data?.message;
    }
    return error;
};

export const loadingCounterWrapper = async (action: any) => {
    putStorage(`loadingCounter`, getStorage((state) => state?.loadingCounter ?? 0) + 1);
    try {
        const response = await action();
        return response;
    } catch (error) {
        throw error;
    } finally {
        await sleep(100);
        putStorage(`loadingCounter`, Math.max(getStorage((state) => state?.loadingCounter ?? 0) - 1, 0));
    }
};

export const POSTOptions = (name: string) => {
    const table = getStorage((state) => state?.tables?.[name] ?? {});
    const { pagination = {}, sort = [], filters: filter = {} } = table;
    const { currentPage = 0, perPage = 10 } = pagination;
    return {
        params: {
            limit: perPage,
            offset: currentPage * perPage,
            ...filter,
        },
    };
};

export const GETOptions = (options = {} as any) => {
    return POSTOptions(options);
};

export const convertPaginatedResponse = (response: any) => {
    const { rows = [], page: currentPage = 0, rowCount: perPage = 10, totalRowCount: totalCount = 0 } = response;
    const data = {
        rows: rows.map((i: any) => Object.fromEntries(i?.cells?.map?.((j: any) => [j?.column, j?.value]))),
        pagination: { currentPage, perPage, totalCount },
    };
    return data;
};
